/**
 * Created by rickborst on 22/02/2017.
 */

import _ from 'lodash';

import {write as writeCookie, read as readCookie, clear as clearCookie} from './manager/cookie';
import {write as writeLocal, read as readLocal, clear as clearLocal} from './manager/local';

const STORAGE_TYPES = {
    LOCAL: 'LOCAL',
    COOKIE: 'COOKIE'
};

let instance;

class StorageManager {

    /**
     * Constructs the manager.
     */
    constructor () {

        this._type = StorageManager._getStorageType();
    }

    /**
     * Returns the storage type.
     *
     * @returns {string} - Storage type.
     * @private
     */
    static _getStorageType () {
        try {
            let storage = window.localStorage,
                x = '__storage_test__';

            storage.setItem(x, x);
            storage.removeItem(x);

            return STORAGE_TYPES.LOCAL;
        } catch (e) {

            return STORAGE_TYPES.COOKIE;
        }
    }

    /**
     * Parses a value to a string.
     *
     * @param {string|number|null|json} value - Value to be parsed.
     * @returns {string} Parsed value.
     * @private
     */
    static _valueToString (value) {

        if (_.isObject(value)) {

            return JSON.stringify(value);
        } else if (!_.isString(value)) {

            return value.toString();
        }

        return value;
    }

    /**
     * Tries to parse a string value into an assumed JSON object.
     * Falls back to a string value.
     *
     * @param {string} string - String.
     * @returns {string|json} Assumed JSON object or string value.
     * @private
     */
    static _valueFromString (string) {
        try {

            return JSON.parse(string);
        } catch (e) {

            return string;
        }
    }

    /**
     * Stores a value under a given key.
     *
     * @param {string} key - Storage key.
     * @param {string|number|null|json} value - To be stored value.
     */
    store (key, value) {
        let storeMethod;

        value = StorageManager._valueToString(value);

        switch (this._type) {

            case STORAGE_TYPES.LOCAL:
                storeMethod = writeLocal;
                break;

            case STORAGE_TYPES.COOKIE:
                storeMethod = writeCookie;
                break;

            default:
                throw new Error('Unsupported storage detected.');
        }

        storeMethod(key, value);
    }

    /**
     * Reads a value from storage under a given key.
     *
     * @param {string} key - Storage key.
     * @returns {string|json|null} - Stored value or null.
     */
    read (key) {
        let readMethod,
            readValue;

        switch (this._type) {

            case STORAGE_TYPES.LOCAL:
                readMethod = readLocal;
                break;

            case STORAGE_TYPES.COOKIE:
                readMethod = readCookie;
                break;

            default:
                throw new Error('Unsupported storage detected.');
        }

        readValue = readMethod(key);

        return StorageManager._valueFromString(readValue);
    }

    /**
     * Clears storage under a given key.
     *
     * @param {string} key - Storage key.
     */
    clear (key) {
        let clearMethod;

        switch (this._type) {

            case STORAGE_TYPES.LOCAL:
                clearMethod = clearLocal;
                break;

            case STORAGE_TYPES.COOKIE:
                clearMethod = clearCookie;
                break;

            default:
                throw new Error('Unsupported storage detected.');
        }

        clearMethod(key);
    }
}

/**
 * Get singleton instance of the manager.
 *
 * @returns {Object} Storage manager.
 */
export function getInstance () {

    if (!instance) {
        instance = new StorageManager();
    }

    return instance;
}


// WEBPACK FOOTER //
// ./src/js/storage/manager.js